import { fetchWithCache, getCachedData } from "../services/apiService";

export const userStats = async ({ setStats }) => {
  // Show cached data immediately if available
  const cached = getCachedData("/api/user/totalUsers", {});
  if (cached) {
    setStats(cached);
  }

  try {
    const data = await fetchWithCache(
      "/api/user/totalUsers",
      {
        method: "GET",
        retries: 2,
        timeout: 10000,
      },
      true,
    );

    if (!data?.error) {
      setStats(data);
    } else if (!cached) {
      setStats(null);
    }
  } catch (error) {
    if (!cached) {
      setStats(null);
    }
  }
};
